import { ThemeProvider } from '@emotion/react';
import { PaletteMode, createTheme } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { THEMEMODE } from '_constants';
import React, { createContext, ReactNode, useMemo, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { getDesignTokens } from './theme';

const ColorModeContext = createContext({ toggleColorMode: () => {} });
const queryClient = new QueryClient();

const BaseWrappers = ({ children }: { children: ReactNode }) => {
  const [mode, setMode] = useState<PaletteMode>(THEMEMODE.light);
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode: PaletteMode) =>
          prevMode === THEMEMODE.light ? THEMEMODE.dark : THEMEMODE.light,
        );
      },
    }),
    [],
  );

  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);
  return (
    <BrowserRouter>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </BrowserRouter>
  );
};
export default BaseWrappers;
